export default function(api: GlobalFetch) {
  return async function(values) {
    await api.fetch(`/api/v2/booking/unconfirm`, {
      method: 'POST',
      body: JSON.stringify(values),
    })
  }
}
